import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppState } from '../../../store';
import { NotifyService } from '../../../common/services/notify.service';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { Hook } from '../../hook.models';
import { selectHooksErrors } from '../../store/hooks/hooks.selectors';

@Component({
  selector: 'hook-form-slack',
  template: `
    <xp-form-validation type="SlackHook" [name]="formName">
      <form name="hookForm" id="hookForm" #form="ngForm">
        <div class="row">
          <div class="col-md-10">
            <div class="form-group">
              <xp-form-group>
                <label id="name-label" for="name">{{ 'hook.form.slack.labels.name' | translate }}</label>
                <xp-input id="name" type="text" name="name" [(ngModel)]="item.name" class="form-control"></xp-input>
              </xp-form-group>
              <small>{{ 'hook.form.slack.hints.name' | translate }}</small>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="status">Active</label>
              <mat-slide-toggle id="status" [checked]="item.active" (toggleChange)="toggleActiveChange()">
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="form-group">
          <xp-form-group>
            <label for="url" id="url-label">{{ 'hook.form.slack.labels.url' | translate }}</label>
            <xp-input type="text" name="url" id="url" [(ngModel)]="item.settings.url" class="form-control"></xp-input>
          </xp-form-group>
          <small>{{ 'hook.form.slack.hints.url' | translate }}</small>
        </div>
        <div class="form-group">
          <xp-form-group>
            <label for="team" id="team-label">{{ 'hook.form.slack.labels.team' | translate }}</label>
            <xp-input
              type="text"
              name="team"
              id="team"
              [(ngModel)]="item.settings.team"
              class="form-control"
            ></xp-input>
          </xp-form-group>
          <small>{{ 'hook.form.slack.hints.team' | translate }}</small>
        </div>
        <div class="form-group">
          <xp-form-group>
            <label for="channel"
              ><span id="channel-label">{{ 'hook.form.slack.labels.channel' | translate }}</span>
              <span class="text-muted">{{ 'generic.labels.optional' | translate }}</span></label
            >
            <xp-input
              type="text"
              name="channel"
              id="channel"
              [(ngModel)]="item.settings.channel"
              class="form-control"
            ></xp-input>
          </xp-form-group>
          <small>{{ 'hook.form.slack.hints.channel' | translate }}</small>
        </div>
        <hook-events-editor [(events)]="item.events"></hook-events-editor>
      </form>
      <errors-notify [errors]="errorTexts"></errors-notify>
    </xp-form-validation>
  `,
})
export class HookFormSlackComponent extends BaseForm implements OnInit, OnDestroy, BaseFormInterface {
  @Input() item: Partial<Hook> = {
    settings: {},
    events: [],
  };
  @Input() slackData: Partial<Hook>;
  @Output() itemChange = new EventEmitter<Hook>();
  @Output() formValidity = new EventEmitter<boolean>();
  @ViewChild('form', { static: true }) form: NgForm;
  formName = 'hookForm';
  successMessageText = 'hook.form.success_message';
  formChangesSubscription: Subscription;
  errors$ = this.store.select(selectHooksErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
    @Inject('$rootScope') private $rootScope: any,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.formChangesSubscription = this.form.form.statusChanges.subscribe(() => {
      this.formValidity.emit(this.form.valid);
    });
  }

  toggleActiveChange() {
    this.item.active = !this.item.active;
  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }
}
